import { AppDivider } from 'components/core/AppDivider/AppDivider';
import { AppLinkRoot } from 'components/core/AppLink/AppLink';
import Grid from 'components/core/Grid';
import { LoginModeEnum } from 'components/views/pages/login/types';
import { AppRoutes } from 'config/appRoutes';
import { userNextRouteTransitions } from 'hooks/useNextRouteTransitions';

interface Props {
  mode: LoginModeEnum;
}

export const LoginFormFooter = ({ mode }: Props) => {
  const isGuestPage = mode === LoginModeEnum.guest;

  const { navigateToGuestSignUp, navigateToListPage } = userNextRouteTransitions();

  return (
    <>
      <Grid item xs={12}>
        <AppDivider />
      </Grid>

      <Grid item xs={12}>
        <AppLinkRoot onClick={navigateToListPage} isButtonLink>
          List Property
        </AppLinkRoot>
      </Grid>
      <Grid item xs={12}>
        <AppLinkRoot onClick={navigateToGuestSignUp} isButtonLink>
          Create Guest Account
        </AppLinkRoot>
      </Grid>
      <Grid item xs={12} align="center">
        {isGuestPage ? (
          <AppLinkRoot href={AppRoutes.loginHost}>Looking for Host Log In?</AppLinkRoot>
        ) : (
          <AppLinkRoot href={AppRoutes.loginGuest}>Looking for Guest Log In?</AppLinkRoot>
        )}
      </Grid>
    </>
  );
};
